/* eslint-disable react/jsx-props-no-spreading */
import PropType from 'prop-types';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { propTypes } from 'react-simple-drawer';
import PlanFeatures from './planFeatures';
import PricingCard from './pricingCard';

/* eslint-disable react/react-in-jsx-scope */
function PricingGrid({
  plans,
  lang,
  billingPeriod,
  firstRender,
  handleSelectPlan,
}) {
  const { app } = useSelector((state) => state);
  const { user } = app;

  const [selectedPlan, setSelectedPlan] = useState(-1);
  function handleChangeSelectedPlan(planId) {
    handleSelectPlan(planId);
    if (selectedPlan === planId) {
      setSelectedPlan(-1);
      return;
    }
    setSelectedPlan(planId);
  }
  return (
    <>
      <div
        className="relative w-full lg:mt-0 flex items-center justify-center flex-wrap gap-x-0 md:gap-x-20"
        role="list">
        {plans?.map((plan, index) => (
          <PricingCard
            subscribed={user.planId === plan.idMonth || user.planId === plan.idYear}
            disabled={user.planId !== null ? true : false}
            key={index}
            lang={lang}
            firstRender={firstRender}
            billingPeriod={billingPeriod}
            {...plan}
            handleChangeSelectedPlan={() => handleChangeSelectedPlan(index)}
          />
        ))}
      </div>
      <div
        className="relative w-full lg:mt-0 flex items-start justify-center flex-wrap gap-x-0 md:gap-x-20 d-none d-md-flex"
        role="list">
        {plans.map((plan, index) => (
          <PlanFeatures key={index} lang={lang} features={plan.features} />
        ))}
      </div>
    </>
  );
}

PricingGrid.propTypes = {
  billingPeriod: PropType.string,
  firstRender: PropType.bool,
  handleSelectPlan: PropType.func,
  plans: PropType.array,
};

export default PricingGrid;
